import React from "react";
import { Link } from "react-router-dom";
import "../styles/TeamContainer.css";
import { HashLink } from "react-router-hash-link";

const TeamContainer = ({image,name,title,location}) => {
  return (
    <div className="col-xl-3 col-lg-6 col-md-6">
      <div className="team-one__single">
        <div className="team-one__img">
          <img src={image} alt="" />
          <div className="team-one__hover-content">
            <h3 className="team-one__name">{name}</h3>
            <p className="team-one__title">{title}</p>
            <p className="team-one__title" style={{ color: "white" }}>
              {location}
            </p>
          </div>
          <div className="team-one__bottom">
            <div className="team-one__btn-box">
              {/* <Link
                to={`/about-team#${name.toLowerCase().replace(" ", "-")}`}
                className="team-one__btn">
                ABOUT ME
              </Link> */}
              <HashLink
                to={`/about-team#${name.toLowerCase().replace(" ", "-")}`}
                className="team-one__btn">
                ABOUT ME
              </HashLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamContainer;
